import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/home'  //首页
import OnlineBusinessSchool from '../views/product/OnlineBusinessSchool/index'  //商学院 
import RetailTraining from '../views/product/RetailTraining/index'  //零售培训
import Consultant from '../views/product/Consultant/index'// Consultant 咨询顾问
import Bosscircle from '../views/product/Bosscircle/index'// Bosscircle
import Cooperationcases from '../views/Cooperationcases/index' // Cooperationcases
import Download from '../views/download/index' // download
import AboutUs from '../views/aboutUs/index' // aboutUs
import Curriculum from '../views/product/details/curriculum' // 课程详情
import Lecturer from '../views/product/details/lecturer' // 讲师详情
import Login from '../views/login/index' // 登录页
import Screen from '../views/screen/index'  //筛选
import Status from '../views/status/index'  //结果
import Form from '../views/form/index'  //表单
import Card from '../views/product/details/card'  //会员卡
import Article from '../views/product/details/article'  //文章详情
import Activity from '../views/product/details/activity'  //活动详情
import Confirm from '../views/order/confirm'  //确认订单
import My from '../views/my/my'  //我的主页
import Set from '../views/my/set'  //个人设置
import TechProduct from '../views/product/TechProduct/index'
import techDetail from '../views/product/TechProduct/detail'
import coursePackage from '../views/product/course/coursePackage'
Vue.use(Router)
// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [{
		path: '/',
		name: '首页',
		meta:{
			keywords:'钧策咨询,零售视界,咨询服务,怎么开超市,超市提升,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案',
      description:'超市用工合同模板,超市保密,超市用工风险,超市税务筹划,超市现金流管理,超市财税管控,超市薪酬绩效,超市预算管控,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案,门店运营数据分析,标准sop落地执行,解决门店标准化管理难题,欢迎前来咨询服务！'
		},
		component: Home
	},
	{
		path: '/login',
		name: '登录中心',
		meta:{
			keywords:'钧策咨询,零售视界,咨询服务,怎么开超市,超市提升,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案',
      description:'零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案,门店运营数据分析,标准sop落地执行,钧策咨询,零售视界,咨询服务,怎么开超市,超市提升,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案,欢迎前来咨询服务！'
		},
		component: Login
	},
	// Activity
	{
		path: '/Activity',
		name: '活动详情',
		meta:{
			keywords:'钧策咨询,零售视界,咨询服务,怎么开超市,超市提升,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案',
      description:'超市用工合同模板,超市保密,超市用工风险,超市税务筹划,超市现金流管理,超市财税管控,超市薪酬绩效,超市预算管控,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案,门店运营数据分析,标准sop落地执行,解决门店标准化管理难题,欢迎前来咨询服务'
		},
		component: Activity
	},
	{
		path: '/OnlineBusinessSchool',
		name: '线上商学院',
		meta:{
			keywords:'钧策咨询,零售视界,咨询服务,怎么开超市,超市提升,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案',
      description:'超市用工合同模板,超市保密,超市用工风险,超市税务筹划,超市现金流管理,超市财税管控,超市薪酬绩效,超市预算管控,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案,门店运营数据分析,标准sop落地执行,解决门店标准化管理难题,欢迎前来咨询服务'
		},
		component: OnlineBusinessSchool
	},
	{
		path: '/RetailTraining',
		name: '零售培训',
		meta:{
			keywords:'零售实时热点课程,零售岗位集训营,源头厂家,零售总裁峰会,零售标杆企业,零售私董会,零售企业内部培训',
      description:'零售实时热点课程,零售岗位集训营,源头厂家,零售总裁峰会,零售标杆企业,零售私董会,零售企业内部培训'
		},
		component: RetailTraining
	},
	{
		path: '/Consultant',
		name: '咨询顾问',
		meta:{
			keywords:'超市新店开业,超市老店整改,超市布局调整,超市业绩提升,超市人员管理,超市员工执行力打造,超市人员管理力提升,超市薪酬体系搭建,超市毛利提升,超市生鲜经营,超市损耗控制,超市流程再造,超市样板店打造,超市配送中心搭建',
      description:'超市新店开业,超市老店整改,超市布局调整,超市业绩提升,超市人员管理,超市员工执行力打造,超市人员管理力提升,超市薪酬体系搭建,超市毛利提升,超市生鲜经营,超市损耗控制,超市流程再造,超市样板店打造,超市配送中心搭建'
		},
		component: Consultant
	},
	{
		path: '/Bosscircle',
		name: '零售老板圈',
		meta:{
			keywords:'商超企业上市,企业投资融资,企业传承,企业二代接班,老板个人成长,组织管理,零售战略创新,零售私董会',
      description:'商超企业上市,企业投资融资,企业传承,企业二代接班,老板个人成长,组织管理,零售战略创新,零售私董会'
		},
		component: Bosscircle
	},
	{
		path: '/TechProduct',
		name: '数字产品',
		meta:{
			keywords:'商超企业上市,企业投资融资,企业传承,企业二代接班,老板个人成长,组织管理,零售战略创新,零售私董会',
      description:'商超企业上市,企业投资融资,企业传承,企业二代接班,老板个人成长,组织管理,零售战略创新,零售私董会'
		},
		component: TechProduct
	},
	{
		path: '/techDetail',
		name: '数字产品详情',
		meta:{
			keywords:'商超企业上市,企业投资融资,企业传承,企业二代接班,老板个人成长,组织管理,零售战略创新,零售私董会',
      description:'商超企业上市,企业投资融资,企业传承,企业二代接班,老板个人成长,组织管理,零售战略创新,零售私董会'
		},
		component: techDetail
	},
	{
		path: '/coursePackage',
		name: '企业商学院',
		meta:{
			keywords:'企业商学院,企业投资融资,企业传承,企业二代接班,老板个人成长,组织管理,零售战略创新,零售私董会',
      description:'商超企业上市,企业投资融资,企业传承,企业二代接班,老板个人成长,组织管理,零售战略创新,零售私董会'
		},
		component: coursePackage
	},
	{
		path: '/Cooperationcases',
		name: '合作案例',
		meta:{
			keywords:'钧策咨询,零售视界,咨询服务,怎么开超市,超市提升,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案',
      description:'超市用工合同模板,超市保密,超市用工风险,超市税务筹划,超市现金流管理,超市财税管控,超市薪酬绩效,超市预算管控,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案,门店运营数据分析,标准sop落地执行,解决门店标准化管理难题,欢迎前来咨询服务'
		},
		component: Cooperationcases
	},
	{
		path: '/Download',
		name: 'APP下载',
		meta:{
			keywords:'钧策咨询,零售视界,咨询服务,怎么开超市,超市提升,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案',
      description:'超市用工合同模板,超市保密,超市用工风险,超市税务筹划,超市现金流管理,超市财税管控,超市薪酬绩效,超市预算管控,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案,门店运营数据分析,标准sop落地执行,解决门店标准化管理难题,欢迎前来咨询服务'
		},
		component: Download
	},
	{
		path: '/AboutUs',
		name: '关于我们',
		meta:{
			keywords:'钧策咨询,零售视界,咨询服务,怎么开超市,超市提升,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案',
      description:'超市用工合同模板,超市保密,超市用工风险,超市税务筹划,超市现金流管理,超市财税管控,超市薪酬绩效,超市预算管控,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案,门店运营数据分析,标准sop落地执行,解决门店标准化管理难题,欢迎前来咨询服务'
		},
		component: AboutUs
	},
	{
		path: '/Curriculum',
		name: '课程详情',
		meta:{
			keywords:'钧策咨询,零售视界,咨询服务,怎么开超市,超市提升,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案',
      description:'超市用工合同模板,超市保密,超市用工风险,超市税务筹划,超市现金流管理,超市财税管控,超市薪酬绩效,超市预算管控,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案,门店运营数据分析,标准sop落地执行,解决门店标准化管理难题,欢迎前来咨询服务'
		},
		component: Curriculum
	},
	{
		path: '/Lecturer',
		name: '讲师详情',
		meta:{
			keywords:'钧策咨询,零售视界,咨询服务,怎么开超市,超市提升,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案',
      description:'超市用工合同模板,超市保密,超市用工风险,超市税务筹划,超市现金流管理,超市财税管控,超市薪酬绩效,超市预算管控,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案,门店运营数据分析,标准sop落地执行,解决门店标准化管理难题,欢迎前来咨询服务'
		},
		component: Lecturer
	},
	// Lecturer
	{
		path: '/Screen',
		name: '筛选',
		meta:{
			keywords:'钧策咨询,零售视界,咨询服务,怎么开超市,超市提升,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案',
      description:'超市用工合同模板,超市保密,超市用工风险,超市税务筹划,超市现金流管理,超市财税管控,超市薪酬绩效,超市预算管控,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案,门店运营数据分析,标准sop落地执行,解决门店标准化管理难题,欢迎前来咨询服务'
		},
		component: Screen
	},
	{
		path: '/Status',
		name: '结果',
		meta:{
			keywords:'钧策咨询,零售视界,咨询服务,怎么开超市,超市提升,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案',
      description:'超市用工合同模板,超市保密,超市用工风险,超市税务筹划,超市现金流管理,超市财税管控,超市薪酬绩效,超市预算管控,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案,门店运营数据分析,标准sop落地执行,解决门店标准化管理难题,欢迎前来咨询服务'
		},
		component: Status
	},
	{
		path: '/Form',
		name: '表单',
		meta:{
			keywords:'钧策咨询,零售视界,咨询服务,怎么开超市,超市提升,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案',
      description:'超市用工合同模板,超市保密,超市用工风险,超市税务筹划,超市现金流管理,超市财税管控,超市薪酬绩效,超市预算管控,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案,门店运营数据分析,标准sop落地执行,解决门店标准化管理难题,欢迎前来咨询服务'
		},
		component: Form
	},
	{
		path: '/Card',
		name: '会员卡详情',
		meta:{
			keywords:'钧策咨询,零售视界,咨询服务,怎么开超市,超市提升,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案',
      description:'超市用工合同模板,超市保密,超市用工风险,超市税务筹划,超市现金流管理,超市财税管控,超市薪酬绩效,超市预算管控,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案,门店运营数据分析,标准sop落地执行,解决门店标准化管理难题,欢迎前来咨询服务'
		},
		component: Card
	},
	{
		path: '/Confirm',
		name: '确认订单',
		meta:{
			keywords:'钧策咨询,零售视界,咨询服务,怎么开超市,超市提升,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案',
      description:'超市用工合同模板,超市保密,超市用工风险,超市税务筹划,超市现金流管理,超市财税管控,超市薪酬绩效,超市预算管控,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案,门店运营数据分析,标准sop落地执行,解决门店标准化管理难题,欢迎前来咨询服务'
		},
		component: Confirm
	},
	{
		path: '/My',
		name: '我的主页',
		meta:{
			keywords:'我的主页',
      description:'我的主页我的主页我的主页我的主页我的主页我的主页我的主页'
		},
		component: My
	},
	{
		path: '/Set',
		name: '个人设置',
		meta:{
			keywords:'个人设置',
      description:'个人设置个人设置个人设置个人设置个人设置个人设置个人设置'
		},
		component: Set
	},
	{
		path: '/Article',
		name: '文章详情',
		meta:{
			keywords:'钧策咨询,零售视界,咨询服务,怎么开超市,超市提升,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案',
      description:'超市用工合同模板,超市保密,超市用工风险,超市税务筹划,超市现金流管理,超市财税管控,超市薪酬绩效,超市预算管控,零售商超企业,零售商学院,线上商学院,培训数据分析系统,培训测评系统,数字化巡店解决方案,门店运营数据分析,标准sop落地执行,解决门店标准化管理难题,欢迎前来咨询服务'
		},
		component: Article
	},
	// Confirm Article
]

const router = new Router({
	routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
	// console.log(to)
	if(!to.name){
		router.push('/')
	}
	if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
	window.scrollTo(0,0);
	if(Object.keys(to.meta).length>0 && to.matched.length>0){
    let this_meta=to.matched[to.matched.length-1].meta
    // console.log(this_meta,'---this_meta---')
    if(this_meta.title)document.title=this_meta.title
    let head = document.getElementsByTagName('head');
    let meta_keyword=document.createElement('meta');
    if(document.querySelector('meta[name="keywords"]')){
      document.querySelector('meta[name="keywords"]').setAttribute('content',this_meta.keywords)
    }else{
      meta_keyword.setAttribute('name','keywords')
      meta_keyword.setAttribute('content',this_meta.keywords)
      head[0].appendChild(meta_keyword)
    }
    let meta_description=document.createElement('meta');
    if(document.querySelector('meta[name="description"]')){
      document.querySelector('meta[name="description"]').setAttribute('content',this_meta.description)
    }else{
      meta_description.setAttribute('name','description')
      meta_description.setAttribute('content',this_meta.description)
      head[0].appendChild(meta_description)
    }
  }
	// console.log(from)
	// if(!to.name){
	// 	console.log(to.name)
	// }
	//beforeEach是router的钩子函数，在进入路由前执行
	// if (to.meta.title) {

	//  //判断是否有标题

	//  console.log(to)
	var title = '钧策咨询-' + to.name
	// console.log(localStorage.getItem('positon'))
	// if (localStorage.getItem('positon')) {
	// 	title = '钧策咨询-' + to.name
	// }
	document.title = title

	// } else {

	//  document.title = '默认title'

	// }

	next()

})
export default router
